exports = module.exports = require("../../../../_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cube-tab-panel{width:100%;-webkit-box-flex:1;-webkit-flex:1 0 auto;flex:1 0 auto}", ""]);

// exports
